<t4-list-view #listVw [options]="listOptions" (onItemSelectionChange)="OnItemSelectionChange($event)"  (onDirectSelection)="actionClick('rowclick', $any($event))" (onDataRequest)="onDataRequest($event)">
  <t4-date-time-control [beforeToday]="false" [labelDate]="'CUSTOM.BUTTON.STATE.FORM.FROM-DATE'" [labelTime]="'CUSTOM.BUTTON.STATE.FORM.FROM-TIME'"></t4-date-time-control>

  <ng-container *t4ListActions>
    @if (allowAdd === true && !isInArchiveMode) {
      <button (click)="actionClick('add')" class="btn btn-primary border" type="button"><i class="far fa-plus-square"></i>{{ 'GENERIC.BUTTON.ADDNEW' | translate}}</button>
    }
  </ng-container>

  <ng-container *t4ListItem="let item">

    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.ExternalId }}">{{ item.CustomerNumber }} / {{item.ExternalId | replaceOnEmpty}}</td>
    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Name }}"><t4-customer-identification-control [isIbaActive]="isIbaActive" [customer]="constructCustomerIdentificationModel(item)"></t4-customer-identification-control></td>
    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Age }}">{{ showAge(item.Age, item.CustomerType) }}</td>
    @if (isCustomerReworkActive) {
      <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.ParentCompanyName }}">{{ item.ParentCompanyName | replaceOnEmpty }}</td>
      <td class= "company-info">
        @if (item.CustomerType == 1) {
          <span class="badge bg-success">{{ 'BTN.YES' | translate }}</span>
        } @else {
          <span class="badge bg-secondary">{{ 'BTN.NO' | translate }}</span>
        }
      </td>
    } @else {
      <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Name }}">{{item.CustomerType == 1 ? item.Name : null | replaceOnEmpty }}</td>
    }
    <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ item.Email }}">{{item.Email}}</td>
    @if (showAddress === true) {
      <td class= "company-info" data-bs-toggle="tooltip" data-bs-placement="bottom" title="{{ getCombinedAddress(item) }}">{{getCombinedAddress(item)}}</td>
    }

    @if (allowEdit) {
      <td class="grid-action">
        @if (!isInArchiveMode) {
          <button (click)="this.actionClick('edit', item)" type="button" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
        }
        @if (!isInArchiveMode) {
          <button (click)="this.actionClick('delete', item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
        }
      </td>
    }


  </ng-container>

  <ng-container *t4ItemFilter="let kvp=kvp">

    <div class="row">
      <div class="col-lg-12">
        <div class="input-group input-group-sm">
          
            <span class="input-group-text mdi mdi-account-search"></span>
          
          <input type="text" class="form-control form-control-filter me-1 filter-input" placeholder="{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.SEARCH' | translate }}" (keyup.enter)='listVw.updateFilter($event)' name="query" [(ngModel)]="kvp.query" autocomplete="off">
        </div>
      </div>
    </div>

    <div class="customer-search-options d-flex flex-wrap align-items-center gap-4 mt-2">
      @if (isCustomerReworkActive) {
        <div class="customer-type-options d-flex align-items-center gap-3">
          <div class="form-check form-check-inline mb-0">
            <input class="form-check-input" type="checkbox" id="includeCompanies" name="includeCompanies" [(ngModel)]="includeCompanies" (change)="onCustomerTypeChange('company')">
            <label class="form-check-label" for="includeCompanies">{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.CUSTOMER-TYPE.COMPANY' | translate }}</label>
          </div>
          <div class="form-check form-check-inline mb-0">
            <input class="form-check-input" type="checkbox" id="includeIndividuals" name="includeIndividuals" [(ngModel)]="includeIndividuals" (change)="onCustomerTypeChange('individual')">
            <label class="form-check-label" for="includeIndividuals">{{ 'RELATIONS.OVERVIEW.FILTERS.LABEL.CUSTOMER-TYPE.INDIVIDUALS' | translate }}</label>
          </div>
        </div>

        <span class="customer-search-options__separator" aria-hidden="true"></span>
      }

      <div class="search-mode-options d-flex align-items-center gap-3">
        <div class="form-check form-check-inline mb-0">
          <input class="form-check-input" type="radio" id="customerSearchModeAll" name="customerSearchMode" value="all" [(ngModel)]="searchMode">
          <label class="form-check-label" for="customerSearchModeAll">{{ 'T4.LIST-VIEW.AI-OPTIONS.SEARCH-MODE.ALL' | translate }}</label>
        </div>
        <div class="form-check form-check-inline mb-0">
          <input class="form-check-input" type="radio" id="customerSearchModeAny" name="customerSearchMode" value="any" [(ngModel)]="searchMode">
          <label class="form-check-label" for="customerSearchModeAny">{{ 'T4.LIST-VIEW.AI-OPTIONS.SEARCH-MODE.ANY' | translate }}</label>
        </div>
      </div>

      <button (click)="showSearchTip = !showSearchTip" class="btn btn-outline-primary btn-small" type="button" data-testid="search-tip-outline-primary" [attr.aria-expanded]="showSearchTip">
        <i class="fas fa-info-circle"></i>{{ 'T4.LIST-VIEW.AI-OPTIONS.TOGGLE' | translate }}
      </button>
    </div>

    @if (showSearchTip) {
      <div class="customer-search-options__tip">
        <strong>{{ 'T4.LIST-VIEW.AI-OPTIONS.PRO-TIP.TITLE' | translate }}:</strong>
        <span [innerHTML]="'T4.LIST-VIEW.AI-OPTIONS.PRO-TIP.TEXT' | translate"></span>
      </div>
    }

  </ng-container>

</t4-list-view>
